import React, { useState } from 'react';
import styles from './Textfield.module.scss';
import { TextfieldProps } from './Textfield.types';

const className = 'textfield';

const Textfield: React.FC<TextfieldProps> = ({
  className: classNameProps,
  name,
  iconLeft,
  iconRight,
  label,
  onChange,
  placeholder,
  ref,
  type = 'text',
  value,
  disabled = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';

  return (
    <>
      {label && <label className={styles[className + '__label']}>
        {label}  
      </label>}
      <div className={[styles[`${className}`], classNameProps].join(' ')}>
        {iconLeft && (
          <span className={styles[`${className}__icon_left`]}>
            {iconLeft}
          </span>
        )}
        <input
          className={styles[`${className}__input`]}
          data-testid="input-textfield"
          disabled={disabled}
          name={name}
          onChange={onChange}
          onClick={e => {
            if (type === 'date') {
              e.currentTarget.showPicker && e.currentTarget.showPicker();
            }
          }}
          placeholder={placeholder}
          ref={ref}
          style={{ flex: 1, paddingRight: isPassword ? 32 : undefined }}
          type={(isPassword && showPassword) ? 'text' : type}
          value={value}
        />
        {isPassword && (
          <button
            type="button"
            className={styles[`${className}__icon_right`]}
            onClick={() => setShowPassword((v) => !v)}
            style={{
              position: 'absolute',
              right: 8,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
            }}
            tabIndex={-1}
          >
            {showPassword ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2589_54984)">
                  <path d="M11.9999 5C16.0554 5 19.3377 7.28597 21.8574 11.4854C22.0474 11.802 22.0474 12.198 21.8574 12.5146C19.3377 16.714 16.0554 19 11.9999 19C7.94441 19 4.66218 16.714 2.14251 12.5146C1.9525 12.198 1.9525 11.802 2.14251 11.4854C4.66218 7.28597 7.94441 5 11.9999 5ZM11.9999 7C9.00117 7 6.39097 8.55916 4.17766 12C6.39097 15.4408 9.00117 17 11.9999 17C14.9986 17 17.608 15.4405 19.8212 12C17.608 8.55947 14.9986 7 11.9999 7ZM11.9999 9C12.7956 9 13.5584 9.3163 14.121 9.87891C14.6836 10.4415 14.9999 11.2043 14.9999 12C14.9999 12.7957 14.6836 13.5585 14.121 14.1211C13.5584 14.6837 12.7956 15 11.9999 15C11.2043 15 10.4414 14.6837 9.87884 14.1211C9.31623 13.5585 8.99993 12.7957 8.99993 12C8.99993 11.2043 9.31623 10.4415 9.87884 9.87891C10.4414 9.3163 11.2043 9 11.9999 9ZM11.9999 11C11.7347 11 11.4804 11.1054 11.2929 11.293C11.1054 11.4805 10.9999 11.7348 10.9999 12C10.9999 12.2652 11.1054 12.5195 11.2929 12.707C11.4804 12.8946 11.7347 13 11.9999 13C12.2651 13 12.5194 12.8946 12.707 12.707C12.8945 12.5195 12.9999 12.2652 12.9999 12C12.9999 11.7348 12.8945 11.4805 12.707 11.293C12.5194 11.1054 12.2651 11 11.9999 11Z" fill="#404040"/>
                </g>
                <defs>
                  <clipPath id="clip0_2589_54984">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>

            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-ath="url(#clip0_2589_54995)">
                  <path d="M2.2929 2.29273C2.65901 1.92662 3.23801 1.90402 3.63079 2.22437L3.70696 2.29273L17.3144 15.9002C17.3637 15.9406 17.4094 15.9863 17.4511 16.0369L21.707 20.2927L21.7753 20.3689C22.0957 20.7617 22.0731 21.3407 21.707 21.7068C21.3408 22.0729 20.7618 22.0955 20.3691 21.7752L20.2929 21.7068L16.5058 17.9197C15.1161 18.6354 13.5711 19.0081 11.9999 18.9988V18.9998L11.997 18.9988C11.9958 18.9988 11.9943 18.9998 11.9931 18.9998V18.9988C7.94072 18.9962 4.66077 16.7114 2.14251 12.5144C1.9525 12.1977 1.9525 11.8018 2.14251 11.4851L2.39446 11.0759C3.4006 9.48089 4.52497 8.17699 5.7763 7.1902L2.2929 3.7068L2.22454 3.63063C1.90419 3.23785 1.92678 2.65885 2.2929 2.29273ZM7.20208 8.61598C6.13034 9.4184 5.11908 10.5369 4.17766 11.9998C6.39097 15.4406 9.00116 16.9998 11.9999 16.9998H12.0068L12.2812 16.9968C13.2186 16.9697 14.1402 16.7716 15.0019 16.4158L13.2919 14.7058C12.8921 14.8969 12.4515 15.0006 11.9999 15.0007C11.2045 15.0008 10.4405 14.6852 9.87786 14.1228C9.31527 13.5603 8.99909 12.7963 8.99895 12.0007C8.99894 11.549 9.10383 11.1089 9.29485 10.7087L7.20208 8.61598ZM12.0019 5.00074C16.0565 5.00148 19.3381 7.28642 21.8574 11.4851C22.0474 11.8018 22.0474 12.1977 21.8574 12.5144C21.1603 13.6761 20.405 14.6929 19.5888 15.5564C19.2094 15.9578 18.5761 15.9758 18.1747 15.5964C17.7736 15.2171 17.7564 14.5847 18.1357 14.1834C18.7207 13.5644 19.2821 12.8365 19.8212 11.9988C17.6081 8.55875 14.9984 6.99977 11.9999 6.99977H11.997C11.4534 6.99839 10.9106 7.05207 10.3779 7.15992C9.83689 7.26917 9.3099 6.91953 9.20012 6.37867C9.09056 5.83743 9.44018 5.30963 9.98137 5.19996C10.6457 5.06547 11.3221 4.99917 11.9999 5.00074V4.99977L12.0009 5.00074L12.0029 4.99977L12.0019 5.00074ZM11.2919 12.7078C11.2977 12.7136 11.3045 12.7187 11.3105 12.7244L11.2724 12.6863C11.279 12.6933 11.2851 12.7009 11.2919 12.7078Z" fill="#212121"/>
                </g>
                <defs>
                <clipPath id="clip0_2589_54995">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
                </defs>
              </svg>

            )}
          </button>
        )}
        {
          iconRight
        }
      </div>
    </>
  );
};

export default React.memo(Textfield);